import MxDetailCardRemaxGlobal from "@rf-l1/page/details/card-remax-global/MxDetailCardAgent";
import React from "react";
import { usePropertyDetailPage } from "../../context/PropertyDetailPageContext";

const PropertyDetailRemaxGlobalCard = () => {
  const { remaxGlobal } = usePropertyDetailPage();

  return <MxDetailCardRemaxGlobal title="Remax Global" status={remaxGlobal} />;
};

export default PropertyDetailRemaxGlobalCard;
